<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ ticketId }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="i" @click="clickMenu(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content v-if="ticket">
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-2">
            <v-container fluid grid-list-xs>
              <v-layout row wrap>
                <v-flex xs12 class="mb-3">
                  <div class="text-xs-left body-2">
                    <span id="spanTicketId">{{ ticketId }}</span>
                    <v-icon small class="ml-3 notranslate" @click="copyToClipbpard(ticketId); selectTextInElement('spanTicketId');">file_copy</v-icon>
                  </div>
                  <h1 class="text-xs-left headline font-weight-bold orange--text text--lighten-2">
                    {{ ticket.title }}
                    <v-btn
                      icon
                      small
                      class="ml-2 mr-0 mt-0 mb-0"
                      @click="showEditTitleDialog"
                    >
                      <v-icon small>edit</v-icon>
                    </v-btn>
                  </h1>
                </v-flex>
                <v-flex xs12 sm6>
                  <h3 class="text-xs-left body-2 font-weight-medium">
                    {{ ticket.ticketCategoryName }}
                    <v-btn
                      icon
                      small
                      class="ml-2 mr-0 mt-0 mb-0"
                      @click="showEditCategoryDialog"
                    >
                      <v-icon small>keyboard_arrow_down</v-icon>
                    </v-btn>
                  </h3>
                </v-flex>
                <v-flex xs12 sm6 class="text-xs-right">
                  <v-btn
                    small
                    flat
                    class="mt-0"
                    @click="markUnread"
                  >
                    <v-icon small class="mr-2">email</v-icon>
                    Mark as unread
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="ticket.salesOrderNo">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="ticket.salesOrderNo">
                  <div class="mt-3 mb-3">
                    Sales Order <span class="font-weight-bold">{{ ticket.salesOrderNo }}</span>
                    <v-btn
                      outline
                      small
                      class="ml-2"
                      :to="'/order/' + ticket.salesOrderNo"
                    >
                      View Order
                    </v-btn>
                  </div>
                </v-flex>
                <v-flex xs12 v-if="ticket.productId || ticket.salesOrderItemProductId">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-layout align-center v-if="ticket.productId || ticket.salesOrderItemProductId">
                    <v-flex xs4 sm3 md2 lg2 text-xs-center>
                      <v-img v-if="ticket.image" :src="ticket.image.thumbUrl" class="ma-3"></v-img>
                      <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                    </v-flex>
                    <v-flex xs8 sm8 md9 lg10 text-xs-left>
                      <div class="font-weight-bold black--text" v-if="ticket.productName"><a :href="def.marketplaceDomain + '/product/' + ticket.productId" target="_blank">{{ ticket.productName }}</a><v-icon small class="ml-2">call_made</v-icon></div>
                      <div class="font-weight-bold black--text" v-if="ticket.salesOrderItemName"><a :href="def.marketplaceDomain + '/product/' + ticket.salesOrderItemProductId" target="_blank">{{ ticket.salesOrderItemName }}</a><v-icon small class="ml-2">call_made</v-icon></div>
                      <div v-for="param in ticket.salesOrderItemParams" :key="param.name" class="mt-2">
                        <span class="font-weight-medium">{{ param.name }}: </span>
                        <span v-if="param.value">{{ param.value }}</span>
                        <div v-if="param.selections">
                          <div v-for="selection in param.selections" :key="selection.name">
                            {{ selection.name }}
                          </div>
                        </div>
                      </div>
                      <div v-for="option in ticket.salesOrderItemOptions" :key="option.optionName">
                        <span class="font-weight-medium">{{ option.optionName }}:</span> <span class="ml-2 font-weight-bold">{{ option.valueName }}</span>
                      </div>
                      <!--<div class="caption mt-3"><strong>Prepared by:</strong>{{ issueItem.itemPreparedBy }}</div>
                      <div class="caption"><strong>Seller has sent:</strong> {{ issueItem.incomingQty }} of {{ issueItem.qty }}</div>-->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-2 pb-2 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2 style="padding-top:12px;padding-left:0;">
                        <span class="font-weight-bold">Status</span>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10>
                        <v-chip :color="ticketStatusColor" text-color="white" style="min-width:130px;">
                          <v-avatar>
                            <v-icon small class="notranslate">{{ ticketStatusIcon }}</v-icon>
                          </v-avatar>
                          <strong>{{ ticket.status.toUpperCase() }}</strong>
                        </v-chip>
                        <v-btn
                          outline
                          small
                          v-if="ticket.status === 'open'"
                          class="ml-2 mr-0 mt-0 mb-0"
                          @click="showCloseTicketDialog"
                        >
                          Close
                        </v-btn>
                        <span v-if="ticket.status === 'open' && ticket.replyDatelineDateTime && ticket.pendingReplyFrom === 'admin'" :class="'ml-3 font-weight-bold' + (ticket.lateReplyInMinutes >= -360 && ticket.lateReplyInMinutes <= 0 ? ' orange--text blink-text' : (ticket.lateReplyInMinutes >0 ? ' red--text blink-text' : ''))">
                          Must reply {{ ticket.replyDatelineDateTimeDisplay }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <span class="font-weight-bold">Created Date</span>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10>
                        {{ ticket.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="ticket.status === 'closed'">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="ticket.status === 'closed'">
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <span class="font-weight-bold">Close Date</span>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10>
                        {{ ticket.closedDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12 v-if="ticket.status === 'open'">
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12 v-if="ticket.status === 'open'">
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <span class="font-weight-bold">Pending reply from</span>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold">
                        {{ ticket.pendingReplyFrom | allCaps }}
                        <span v-if="ticket.pendingReplyFromSellerStoreName" class="ml-1">({{ ticket.pendingReplyFromSellerStoreName }})</span>
                        <v-btn
                          icon
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          @click="showEditPendingReplyStatusDialog"
                        >
                          <v-icon small>keyboard_arrow_down</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs46 sm3 md3 lg2>
                        <span class="font-weight-bold">Created by</span>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10>
                        <div v-if="ticket.createdByUserStoreId">
                          {{ ticket.createdByUserLoginEmail }} ({{ ticket.createdByUserStoreName + ' - ' + ticket.createdByUserStoreType }})
                          <!--<v-btn
                            outline
                            small
                            class="ml-2"
                            :to="'/tickets/all?email=' + ticket.createdByUserLoginEmail"
                          >
                            Other tickets
                          </v-btn>-->
                        </div>
                        <div v-else-if="ticket.createdByUserId">
                          {{ ticket.createdByUserLoginEmail }} (buyer)
                          <v-btn
                            outline
                            small
                            class="ml-2 mr-0 mt-0 mb-0"
                            :to="'/customer/' + ticket.createdByUserId + '/orders'"
                          >
                            Order History
                          </v-btn>
                          <v-btn
                            outline
                            small
                            class="ml-2 mr-0 mt-0 mb-0"
                            :to="'/customer/' + ticket.createdByUserId + '/transactions'"
                          >
                            Transactions
                          </v-btn>
                          <v-btn
                            outline
                            small
                            class="ml-2"
                            :to="'/tickets/all?email=' + ticket.createdByUserLoginEmail"
                          >
                            Other tickets
                          </v-btn>
                        </div>
                        <div v-else-if="ticket.createdByEmail">
                          {{ ticket.createdByEmail }} (email)
                          <v-btn
                            outline
                            small
                            class="ml-2 mr-0 mt-0 mb-0"
                            :to="'/tickets/all?email=' + ticket.createdByEmail"
                          >
                            Other tickets
                          </v-btn>
                        </div>
                        <div v-else-if="ticket.createdByAdminId">
                          {{ ticket.createdByAdminName }} (admin)
                          <v-btn
                            outline
                            small
                            class="ml-2 mr-0 mt-0 mb-0"
                          >
                            Other tickets
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2 class="mt-1">
                        <span class="font-weight-bold">Buyer</span>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10 class="font-weight-bold" v-if="ticket.buyers.length > 0">
                        <v-chip :close="isUpdateTicketPermission" @input="removeBuyer(ticket.buyers[0])">{{ ticket.buyers[0].loginEmail }}</v-chip>
                        <v-btn
                          outline
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          :to="'/customer/' + ticket.buyers[0].userId + '/orders'"
                        >
                          Order History
                        </v-btn>
                        <v-btn
                          outline
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          :to="'/customer/' + ticket.buyers[0].userId + '/transactions'"
                        >
                          Transactions
                        </v-btn>
                          <v-btn
                            outline
                            small
                            class="ml-2 mr-0 mt-0 mb-0"
                            :to="'/tickets/all?email=' + ticket.buyers[0].loginEmail"
                          >
                            Other tickets
                          </v-btn>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold" v-else>
                        -
                        <v-btn
                          outline
                          icon
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          @click="showAddBuyerDialog"
                        >
                          <v-icon small>add</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <div class="font-weight-bold mt-3">Admins</div>
                      </v-flex>
                      <v-flex xs8 sm6 md7 lg8 class="font-weight-bold" v-if="admins && admins.length > 0">
                        <v-combobox
                          v-model="ticket.admins"
                          :items="admins"
                          item-text="name"
                          item-value="adminId"
                          label=""
                          hide-details
                          chips
                          multiple
                          @change="updateAdmins($event)"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              :selected="data.selected"
                              close
                              @input="removeAdmin(data.item)"
                            >
                              <v-avatar v-if="data.item.isPrimaryHandler === 1">
                                <v-icon color="orange">account_circle</v-icon>
                              </v-avatar>
                              <strong>{{ data.item.name }}</strong>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <v-flex xs6 sm3 md2 lg2 class="font-weight-bold text-xs-right text-sm-center mt-3" v-if="admins.length > 0">
                        <v-btn
                          outline
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          :disabled="ticket.admins.length <= 1"
                          @click="showEditAdminPrimaryHandlerDialog"
                        >
                          Change Primary
                        </v-btn>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold" v-if="admins && admins.length === 0">
                        <v-chip v-for="admin in ticket.admins" :key="admin.userId">
                          <v-avatar v-if="admin.isPrimaryHandler === 1">
                            <v-icon color="orange">account_circle</v-icon>
                          </v-avatar>
                          {{ admin.name }}
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <div class="font-weight-bold mt-3">Sellers</div>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold" v-if="admins && admins.length > 0">
                        <v-combobox
                          v-model="ticket.sellers"
                          :items="sellers"
                          item-text="storeName"
                          item-value="storeId"
                          label=""
                          hide-details
                          chips
                          multiple
                          @change="updateSellers($event)"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              :selected="data.selected"
                              close
                              @input="removeSeller(data.item)"
                            >
                              <v-avatar>
                                <v-icon color="orange" class="ml-2">store</v-icon>
                              </v-avatar>
                              <strong>{{ data.item.storeName }} ({{ data.item.storeType }})</strong>
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold" v-else>
                        <v-chip v-for="seller in ticket.sellers" :key="seller.userId">
                          <v-avatar v-if="seller.isPrimaryHandler === 1">
                            <v-icon color="orange">account_circle</v-icon>
                          </v-avatar>
                          {{ seller.storeName }} ({{ seller.storeType }})
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex xs12>
                  <v-container fluid grid-list-xs class="pt-3 pb-3 pl-2">
                    <v-layout row wrap>
                      <v-flex xs4 sm3 md3 lg2>
                        <div class="font-weight-bold mt-2">Emails</div>
                      </v-flex>
                      <v-flex xs6 sm9 md9 lg10 class="font-weight-bold" v-if="ticket.emails.length > 0">
                        <v-chip close @input="removeEmail(ticket.emails[0].email)">{{ ticket.emails[0].email }}</v-chip>
                        <v-btn
                          outline
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          :to="'/tickets/all?email=' + ticket.emails[0].email"
                        >
                          Other tickets
                        </v-btn>
                      </v-flex>
                      <v-flex xs8 sm9 md9 lg10 class="font-weight-bold" v-else>
                        -
                        <v-btn
                          outline
                          icon
                          small
                          class="ml-2 mr-0 mt-0 mb-0"
                          v-if="isUpdateTicketPermission"
                          @click="showAddEmailDialog"
                        >
                          <v-icon small>add</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-divider></v-divider>
                </v-flex>

                <v-flex xs12 class="mt-5">
                  <v-container v-for="msg in ticket.messages" :key="msg.ticketMessageId" fluid grid-list-md class="pa-2">
                    <v-layout row wrap :class="(msg.isNotification === 1 ? 'orange lighten-4 black--text' : 'grey darken-2')">
                      <v-flex xs3 sm2 md2 lg1 class="text-xs-center">
                        <div class="mt-4" v-if="msg.createdByUserStoreId.length > 0">
                          <v-icon large :class="(msg.isNotification === 1 ? 'black--text' : '')">store</v-icon>
                          <div>
                            <div>{{ msg.createdByUserStoreName }}</div>
                          </div>
                        </div>
                        <div class="mt-4" v-else-if="msg.createdByUserId.length > 0">
                          <v-icon large :class="(msg.isNotification === 1 ? 'black--text' : '')">face</v-icon>
                          <div>
                            <div>Buyer</div>
                            <div>{{ msg.createdByUserFirstName }} {{ msg.createdByUserLastName }}</div>
                          </div>
                        </div>
                        <div class="mt-4" v-else-if="msg.createdByEmail.length > 0">
                          <v-icon large :class="(msg.isNotification === 1 ? 'black--text' : '')">email</v-icon>
                          <div>
                            <div class="caption" style="word-wrap:break-word;">{{ msg.createdByEmail }}</div>
                          </div>
                        </div>
                        <div class="mt-4" v-else-if="msg.createdByAdminId.length > 0">
                          <v-icon large :class="(msg.isNotification === 1 ? 'black--text' : '')">perm_identity</v-icon>
                          <div>
                            <div>Admin</div>
                            <div>{{ msg.createdByAdminName }}</div>
                          </div>
                        </div>
                        <div class="mt-4" v-else>
                          <v-icon large :class="(msg.isNotification === 1 ? 'black--text' : '')">settings_system_daydream</v-icon>
                          <div>
                            <div>System</div>
                          </div>
                        </div>
                      </v-flex>
                      <v-flex xs9 sm10 md10 lg11 class="pa-4">
                        <v-container fluid grid-list-md class="pa-0">
                          <v-layout row wrap>
                            <v-flex xs8 md9 class="text-xs-left">
                              <div v-if="msg.createdByUserId.length > 0" class="font-weight-bold">
                                {{ msg.createdByUserTitle }} {{ msg.createdByUserFirstName }} {{ msg.createdByUserLastName }}
                              </div>
                              <div v-else-if="msg.createdByEmail.length > 0" class="font-weight-bold">
                                {{ msg.createdByEmail }}
                              </div>
                              <div v-else-if="msg.createdByAdminId.length > 0" class="font-weight-bold">
                                {{ msg.createdByAdminName }}
                              </div>
                              <div class="font-italic caption">{{ msg.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                            </v-flex>
                            <v-flex xs4 md3 class="text-xs-right">
                              <div v-if="msg.isNotification === 1" class="orange--text text--lighten-2">
                                <v-icon small class="red--text">announcement</v-icon>
                                <span class="red--text ml-2">Notification</span>
                              </div>
                              <div v-if="msg.isPrivateMessageForAdmin === 1" class="orange--text text--lighten-2">
                                <v-icon small class="orange--text text--lighten-2">visibility</v-icon>
                                <span class="ml-2">Private for admin</span>
                              </div>
                              <div v-if="msg.isPrivateMessageForSeller === 1" class="orange--text text--lighten-2">
                                <v-icon small class="orange--text text--lighten-2">visibility</v-icon>
                                <span class="ml-2">Private for seller</span>
                              </div>
                            </v-flex>
                            <v-flex xs12 class="text-xs-left">
                              <div class="mt-3" v-html="msg.message"></div>
                            </v-flex>
                            <v-flex xs12 v-if="msg.files && msg.files.length > 0" class="text-xs-left mt-5">
                              <div class="font-weight-bold">Uploaded files</div>
                              <ul>
                                <li v-for="file in msg.files" :key="file.ticketFileId">
                                  <a :href="file.url" class="white--text">{{ file.fileName }}</a>
                                </li>
                              </ul>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs12 class="mt-5 pa-4">
                  <v-form ref="frmMessage" v-model="frmMessageValid">
                  <v-container fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <trumbowyg id="trumbowyg" v-model="txtMessage" :config="trumbowygConfig"></trumbowyg>
                        <!--<v-textarea
                          outline
                          v-model="txtMessage"
                          label="Your message"
                          :rules="[v => !!v || 'Message is required']"
                          required
                        ></v-textarea>-->
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          v-model="switchPrivateMessageForAdmin"
                          color="primary"
                          label="Private message for admin"
                          hide-details
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm6 v-if="ticket && ticket.sellers.length > 0">
                        <v-switch
                          v-model="switchPrivateMessageForSeller"
                          color="primary"
                          label="Private message for seller"
                          hide-details
                        ></v-switch>
                      </v-flex>
                      <v-flex sm6 v-if="switchPrivateMessageForSeller">
                        <v-select
                          v-model="cboPendingReplyFromSellerId"
                          :items="ticket.stores"
                          item-text="storeName"
                          item-value="sellerUserId"
                          label="Also set as pending from seller"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 class="mt-4">
                        <div class="font-weight-bold">UPLOADED FILES</div>
                        <v-list v-if="fileUploads.length > 0" style="background-color:transparent;">
                          <template v-for="(file, fileIndex) in fileUploads">
                            <v-list-tile
                              :key="fileIndex"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title class="body-2">
                                  {{ file.name }}
                                  <v-btn
                                    icon
                                    small
                                    class="ml-2 mr-0 mt-0 mb-0"
                                    @click="removeFileUpload(fileIndex)"
                                  >
                                    <v-icon small>close</v-icon>
                                  </v-btn>
                                  <span v-if="file.uploadStatus && file.uploadStatus === 'success'" class="green--text ml-3">
                                    <v-icon small color="green" class="mr-1">done</v-icon>
                                    Uploaded
                                  </span>
                                  <span v-if="file.uploadStatus && file.uploadStatus === 'uploading'" class="orange--text ml-3">
                                    <v-icon small color="orange" class="mr-1">hourglass_empty</v-icon>
                                    Uploading
                                  </span>
                                  <span v-if="file.uploadStatus && file.uploadStatus === 'error'" class="red--text ml-3">
                                    <v-icon small color="red" class="mr-1">close</v-icon>
                                    Upload failed
                                  </span>
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                        <input
                          type="file"
                          multiple
                          style="display: none"
                          ref="filePicker"
                          accept="*"
                          @change="onFilePicked"
                          @click="$refs.filePicker.value = null"
                        >
                        <div>
                          <span v-if="fileUploads.length === 0" class="grey--text">No file uploaded</span>
                          <v-btn
                            outline
                            small
                            v-if="fileUploads.length < 3"
                            @click="pickFile"
                          >
                            Add file
                          </v-btn>
                        </div>
                      </v-flex>
                      <v-flex xs12 class="mt-5">
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-btn
                          outline
                          :disabled="!frmMessageValid"
                          @click="sendMessage()"
                        >
                          {{ (ticket.status === 'open' ? 'Send Message' : 'Reopen Ticket') }}
                        </v-btn>
                      </v-flex>
                      <v-flex xs12 sm6 class="text-xs-left text-sm-right">
                        <v-btn
                          outline
                          v-if="ticket.status === 'open'"
                          @click="showCloseTicketDialog"
                        >
                          Close
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="dialogEditTitle" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Edit Title</v-card-title>
          <v-card-text>
            <v-form ref="frmEditTitle" v-model="frmEditTitleValid" @submit.prevent="">
              <v-text-field
                v-model="txtEditTitle"
                :rules="[v => !!v || 'Title is required']"
                label="Title"
                @keyup.enter="editTitle"
                required
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmEditTitleValid"
                @click="editTitle"
              >
                Edit Title
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditCategory" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Edit Category</v-card-title>
          <v-card-text>
            <v-form ref="frmEditCategory" v-model="frmEditCategoryValid">
              <v-select
                v-model="cboEditCategoryId"
                :rules="[v => !!v || 'Category is required']"
                :items="categories"
                item-text="name"
                item-value="ticketCategoryId"
                label="Category"
                required
              ></v-select>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmEditCategoryValid"
                @click="editCategory"
              >
                Edit Category
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditPendingReplyStatus" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Edit Pending Reply Status</v-card-title>
          <v-card-text>
            <v-form ref="frmEditPendingReplyStatus" v-model="frmEditPendingReplyStatusValid">
              <v-select
                v-model="cboEditPendingReplyStatus"
                :rules="[v => !!v || 'Status is required']"
                :items="pendingReplyStatuses"
                item-text="name"
                item-value="value"
                label="Status"
                required
              ></v-select>
              <v-select
                v-if="cboEditPendingReplyStatus === 'seller'"
                v-model="cboEditPendingReplyFromSellerId"
                :rules="[v => !!v || 'Seller is required']"
                :items="ticket.stores"
                item-text="storeName"
                item-value="sellerUserId"
                label="Seller"
                required
              ></v-select>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmEditPendingReplyStatusValid"
                @click="editPendingReplyStatus(cboEditPendingReplyStatus, cboEditPendingReplyFromSellerId)"
              >
                Edit Status
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogEditAdminPrimaryHandler" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Edit Admin Primary Handler</v-card-title>
          <v-card-text>
            <v-form ref="frmEditAdminPrimaryHandler" v-model="frmEditAdminPrimaryHandlerValid">
              <v-select
                v-model="cboEditAdminPrimaryHandler"
                :rules="[v => !!v || 'Please select admin']"
                :items="ticket.admins"
                item-text="name"
                item-value="adminId"
                label="Status"
                required
              ></v-select>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmEditAdminPrimaryHandlerValid"
                @click="editAdminPrimaryHandler"
              >
                Set Primary Handler
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddBuyer" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Buyer</v-card-title>
          <v-card-text>
            <v-form ref="frmAddBuyer" v-model="frmAddBuyerValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddBuyerUserId"
                :rules="[v => !!v || 'Buyer is required']"
                label="Buyer Id / Email"
                required
                @keyup.enter="addBuyer"
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddBuyerValid"
                @click="addBuyer"
              >
                Add Buyer
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddEmail" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Email</v-card-title>
          <v-card-text>
            <v-form ref="frmAddEmail" v-model="frmAddEmailValid" @submit.prevent="">
              <v-text-field
                v-model="txtAddEmail"
                :rules="[v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Invalid email format']"
                label="Email"
                @keyup.enter="addEmail"
                required
              ></v-text-field>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddEmailValid"
                @click="addEmail"
              >
                Add Email
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCloseTicket" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Close Ticket</v-card-title>
          <v-card-text>
            <v-form ref="frmCloseTicket" v-model="frmCloseTicketValid">
              <v-textarea
                v-model="txtCloseTicketMessage"
                :rules="[v => !!v || 'Closing message is required']"
                label="Closing Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmCloseTicketValid"
                @click="closeTicket"
              >
                Close Ticket
              </v-btn>
              <div class="text-xs-right">
                <v-btn
                  small
                  right
                  flat
                  class="caption"
                  color="grey"
                  @click="closeTicketWithoutMsg"
                >
                  Close Ticket Without Msg
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="subheading">Confirm to delete this ticket?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteTicket()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--<v-dialog v-model="dialogVerificationRequest" @keydown.esc="dialogVerificationRequest = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold mb-0">Request for verification</h3>
          </v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="frmVerificationRequestValid" class="mt-0">
              <v-select
                v-model="cboTemplateId"
                :rules="[v => !!v || 'Please choose a template']"
                :items="verificationTemplates"
                item-text="name"
                item-value="templateId"
                label="Template"
                @change="loadVerificationTemplate(cboTemplateId)"
                required
              ></v-select>
              <v-text-field
                v-model="txtVerificationSubject"
                :rules="[v => !!v || 'Subject is required']"
                label="Subject"
                required
              ></v-text-field>
              <v-btn
                block
                color="primary"
                :disabled="!frmVerificationRequestValid"
                @click="requestForVerification()"
              >
                Send
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>-->
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

  </div>
</template>

<style scoped>

form >>> div.trumbowyg-box.trumbowyg-editor-visible.trumbowyg-en.trumbowyg {
  z-index: 1;
}

.item-thumb {
  width: 100%;
  min-width: 60px;
  height: auto;
  border: 1px solid #dedede;
}

</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'
import moment from 'moment'
import { EventBus } from '../main'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.css'
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.js'
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js'

let $ = window.$

export default {
  props: [
    'ticketId'
  ],
  components: {
    SideDrawer,
    Loading,
    Trumbowyg
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      isUpdateTicketPermission: false,
      menuItems: [
        { title: 'Delete' }
      ],
      ticket: null,
      ticketStatusColor: '',
      ticketStatusIcon: '',
      dialogEditTitle: false,
      frmEditTitleValid: false,
      txtEditTitle: '',
      dialogEditCategory: false,
      frmEditCategoryValid: false,
      cboEditCategoryId: '',
      categories: [],
      dialogEditPendingReplyStatus: false,
      frmEditPendingReplyStatusValid: false,
      cboEditPendingReplyStatus: '',
      cboEditPendingReplyFromSellerId: '',
      pendingReplyStatuses: [
        {
          name: 'ADMIN',
          value: 'admin'
        },
        {
          name: 'SELLER',
          value: 'seller'
        },
        {
          name: 'BUYER',
          value: 'buyer'
        }
      ],
      dialogEditAdminPrimaryHandler: false,
      frmEditAdminPrimaryHandlerValid: false,
      cboEditAdminPrimaryHandler: '',
      dialogDelete: false,
      dialogAddBuyer: false,
      frmAddBuyerValid: false,
      txtAddBuyerUserId: '',
      admins: [],
      sellers: [],
      dialogAddEmail: false,
      frmAddEmailValid: false,
      txtAddEmail: '',
      frmMessageValid: false,
      txtMessage: '',
      switchPrivateMessageForAdmin: false,
      switchPrivateMessageForSeller: false,
      cboPendingReplyFromSellerId: '',
      fileUploads: [],
      dialogCloseTicket: false,
      frmCloseTicketValid: false,
      txtCloseTicketMessage: '',
      trumbowygConfig: {
        imageWidthModalEdit: true,
        btns: [
          ['undo', 'redo'], // Only supported in Blink browsers
          ['formatting'],
          ['strong', 'em', 'del'],
          ['fontsize'],
          ['foreColor', 'backColor'],
          ['superscript', 'subscript'],
          ['link'],
          ['insertImage'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['horizontalRule'],
          ['removeformat'],
          ['upload']
        ],
        plugins: {
          upload: {
            serverPath: process.env.VUE_APP_API_ROOT + '/v1/ticket/wysiwyg/image',
            fileFieldName: 'image',
            headers: {
              'Authorization': axios.defaults.headers.common['Authorization'],
              'X-API-KEY': axios.defaults.headers.common['X-API-KEY']
            },
            urlPropertyName: 'url'
          },
          resizimg: {
            minSize: 64
          }
        }
      }
    }
  },
  computed: {
  },
  created () {
    var _this = this
    EventBus.$on('profileUpdated', profile => {
      _this.profile = profile
      _this.isUpdateTicketPermission = _this.checkPermission(_this.profile, 'PEM-TICKET', 'update')
    })
  },
  mounted () {
    console.log($)
    this.openDrawerForDesktop()
    this.getTicket()
    this.getAdmins()
    this.getSellers()
    this.getCategories()
  },

  watch: {
  },

  methods: {
    clickMenu: function (menuTitle) {
      switch (menuTitle) {
        case 'Delete':
          this.dialogDelete = true
          break
      }
    },
    deleteTicket: function () {
      var _this = this

      _this.loading = true
      var url = process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId
      axios.delete(url)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            if (window.history.length > 2) {
              _this.goBack()
            } else {
              router.push('/tickets')
            }
          } else {
            console.log('unable to delete ticket: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log('getPaymentMethods : ' + error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.fileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.fileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.fileUploads.splice(fileIndex, 1)
    },
    markUnread: function () {
      var _this = this
      _this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/unread', null)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.goBack()
          } else {
            window.alert('Unable to mark unread: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login')
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showEditTitleDialog: function () {
      this.frmEditTitleValid = false
      this.txtEditTitle = this.ticket.title
      this.dialogEditTitle = true
    },
    editTitle () {
      if (this.$refs.frmEditTitle.validate()) {
        var _this = this
        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId, {
          title: _this.txtEditTitle
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogEditTitle = false
              _this.getTicket()
            } else {
              window.alert('Unable to edit title: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    generateCategoryListRecursive: function (inputCategories, output, level) {
      var strPad = ''
      for (var j = 0; j < level; j++) {
        strPad = strPad + '----'
      }
      for (var i = 0; i < inputCategories.length; i++) {
        inputCategories[i].level = level
        inputCategories[i].name = strPad + ' ' + inputCategories[i].name
        output.push(inputCategories[i])
        if (inputCategories[i].childs.length > 0) {
          output = this.generateCategoryListRecursive(inputCategories[i].childs, output, level + 1)
        }
      }
      return output
    },
    getCategories: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/ticket/categories')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            var categories = []
            _this.categories = this.generateCategoryListRecursive(resp.data.data, categories, 0)
          } else {
            console.log('unable to load categories: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showEditCategoryDialog: function () {
      this.frmEditCategoryValid = false
      this.cboEditCategoryId = this.ticket.ticketCategoryId
      this.dialogEditCategory = true
    },
    editCategory: function () {
      var _this = this
      _this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId, {
        ticketCategoryId: _this.cboEditCategoryId
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getTicket()
            _this.dialogEditCategory = false
          } else {
            window.alert('Unable to update category: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showEditAdminPrimaryHandlerDialog: function () {
      this.frmEditAdminPrimaryHandlerValid = true
      for (var i in this.ticket.admins) {
        if (this.ticket.admins[i].isPrimaryHandler === 1) {
          this.cboEditAdminPrimaryHandler = this.ticket.admins[i].adminId
          break
        }
      }
      this.dialogEditAdminPrimaryHandler = true
    },
    editAdminPrimaryHandler () {
      if (this.$refs.frmEditAdminPrimaryHandler.validate()) {
        var _this = this
        var ticketAdmins = _this.deepCopy(_this.ticket.admins)

        // reset primary handler status for all admins
        for (var i in ticketAdmins) {
          ticketAdmins[i].isPrimaryHandler = 0
        }

        // set new primary handler status
        for (var j in ticketAdmins) {
          if (ticketAdmins[j].adminId === _this.cboEditAdminPrimaryHandler) {
            ticketAdmins[j].isPrimaryHandler = 1
          }
        }

        _this.loading = true
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/admins', {
          admins: ticketAdmins
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogEditAdminPrimaryHandler = false
              _this.getTicket()
            } else {
              window.alert('Unable to edit admin primary handler: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    showEditPendingReplyStatusDialog: function () {
      this.frmEditPendingReplyStatusValid = false
      this.cboEditPendingReplyStatus = this.ticket.pendingReplyFrom
      this.cboEditPendingReplyFromSellerId = this.ticket.pendingReplyFromSellerUserId
      this.dialogEditPendingReplyStatus = true
    },
    editPendingReplyStatus (status, sellerId = '') {
      if (status.length > 0) {
        var _this = this
        _this.loading = true

        var submitData = {
          pendingReplyFrom: status
        }
        if (status === 'seller' && sellerId.length > 0) {
          submitData['pendingReplyFromSellerUserId'] = sellerId
        }
        axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId, submitData)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogEditPendingReplyStatus = false
              _this.getTicket()
            } else {
              window.alert('Unable to edit status: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      } else {
        window.alert('status is required')
      }
    },
    getAdmins: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/admins')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.admins = resp.data.data
          } else {
            console.log('unable to load admin list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              console.log(error.response)
            }
            _this.loading = false
          }
        })
    },
    updateAdmins: function (newAdmins) {
      var _this = this
      _this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/admins', {
        admins: newAdmins
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getTicket()
          } else {
            window.alert('Unable to update admins: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    removeAdmin: function (item) {
      var _this = this
      if (item.isPrimaryHandler === 0) {
        _this.loading = true
        axios.delete(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/admin/' + item.adminId, null)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.ticket.admins.splice(_this.ticket.admins.indexOf(item), 1)
              _this.ticket.admins = [..._this.ticket.admins]
              _this.getTicket()
            } else {
              window.alert('Unable to delete admin: ' + resp.data.message)
              _this.getTicket()
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      } else {
        window.alert('Unable to remove primary handler')
      }
    },
    getSellers: function () {
      this.loading = true
      let _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,branch,franchise')
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.sellers = resp.data.data
          } else {
            console.log('unable to load seller list: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              console.log(error.response)
            }
            _this.loading = false
          }
        })
    },
    updateSellers: function (newSellers) {
      var _this = this
      var sellerUserIds = []
      for (var i in newSellers) {
        sellerUserIds.push(newSellers[i].userId)
      }

      _this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/users', {
        sellerUserIds: sellerUserIds
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getTicket()
          } else {
            window.alert('Unable to update sellers: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    removeSeller: function (item) {
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/user/' + item.userId, null)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.ticket.sellers.splice(_this.ticket.sellers.indexOf(item), 1)
            _this.ticket.sellers = [..._this.ticket.sellers]
            _this.getTicket()
          } else {
            window.alert('Unable to delete seller: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showAddBuyerDialog: function () {
      this.frmAddBuyerValid = false
      this.txtAddBuyerUserId = ''
      this.dialogAddBuyer = true
    },
    addBuyer () {
      var _this = this
      if (_this.$refs.frmAddBuyer.validate()) {
        if (_this.txtAddBuyerUserId.includes('@')) {
          _this.loading = true
          axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + _this.txtAddBuyerUserId)
            .then(resp => {
              if (resp.data.status === 'success') {
                _this.addBuyerByUserId(resp.data.data.userId)
              } else {
                _this.loading = false
                window.alert('Invalid buyer: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.addBuyerByUserId(_this.txtAddBuyerUserId)
        }
      }
    },
    addBuyerByUserId (buyerUserId) {
      var _this = this
      _this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/users', {
        userId: buyerUserId
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.dialogAddBuyer = false
            _this.getTicket()
          } else {
            window.alert('Unable to add buyer: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    removeBuyer: function (item) {
      console.log(item)
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/user/' + item.userId, null)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.ticket.buyers.splice(_this.ticket.buyers.indexOf(item), 1)
            _this.ticket.buyers = [..._this.ticket.buyers]
            _this.getTicket()
          } else {
            window.alert('Unable to delete buyer: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    showAddEmailDialog: function () {
      this.frmAddEmailValid = false
      this.txtAddEmail = ''
      this.dialogAddEmail = true
    },
    addEmail () {
      if (this.$refs.frmAddEmail.validate()) {
        var _this = this
        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/emails', {
          emails: [_this.txtAddEmail]
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogAddEmail = false
              _this.getTicket()
            } else {
              window.alert('Unable to add email: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    removeEmail: function (item) {
      console.log(item)
      var _this = this
      _this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/email/' + item.email, null)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.ticket.emails.splice(_this.ticket.emails.indexOf(item), 1)
            _this.ticket.emails = [..._this.ticket.emails]
            _this.getTicket()
          } else {
            window.alert('Unable to delete email: ' + resp.data.message)
            _this.getTicket()
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    getTicket: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.ticket = resp.data.data
            _this.ticket.replyDatelineDateTimeDisplay = moment(_this.ticket.replyDatelineDateTime, _this.iso8601Format()).fromNow()

            if (_this.ticket.status === 'open') {
              _this.ticketStatusColor = 'orange'
              _this.ticketStatusIcon = 'loop'
            } else if (_this.ticket.status === 'closed') {
              _this.ticketStatusColor = 'green darken-3'
              _this.ticketStatusIcon = 'done'
            }

            // copy buyers
            _this.ticket.buyers = []
            for (var i in _this.ticket.users) {
              if (_this.ticket.users[i].role === 'buyer') {
                _this.ticket.buyers.push(_this.deepCopy(_this.ticket.users[i]))
              }
            }

            // copy sellers
            _this.ticket.sellers = []
            for (var j in _this.ticket.users) {
              if (_this.ticket.users[j].role === 'seller' && _this.ticket.users[j].isPrimaryHandler === 1) {
                _this.ticket.sellers.push(_this.deepCopy(_this.ticket.users[j]))
              }
            }

            _this.$store.dispatch('UPDATE_PROFILE')
          } else {
            console.log('unable to load ticket: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            _this.loading = false
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
        })
    },
    sendMessage () {
      var _this = this
      if (_this.$refs.frmMessage.validate()) {
        _this.loading = true

        // inject files
        var i, j
        var isUploadFile = false
        var formData = new FormData()
        for (i in _this.fileUploads) {
          if (typeof _this.fileUploads[i].uploadStatus === 'undefined' || _this.fileUploads[i].uploadStatus !== 'success') {
            formData.append('file' + (parseInt(i) + 1), _this.fileUploads[i].file, _this.fileUploads[i].name)
            _this.fileUploads[i].uploadStatus = 'uploading'
            isUploadFile = true
          }
        }

        if (isUploadFile) {
          // upload files
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var errorCount = 0
                for (i = 1; i <= 3; i++) {
                  if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].ticketFileId !== 'undefined') {
                    for (j in _this.fileUploads) {
                      if (resp.data.data['file' + i].fileName === _this.fileUploads[j].name) {
                        if (typeof resp.data.data['file' + i].ticketFileId !== 'undefined') {
                          _this.fileUploads[j].ticketFileId = resp.data.data['file' + i].ticketFileId
                          _this.fileUploads[j].uploadStatus = 'success'
                        } else {
                          _this.fileUploads[j].uploadStatus = 'error'
                          errorCount++
                        }
                        break
                      }
                    }
                  }
                }

                // only continue if all upload success
                if (errorCount === 0) {
                  _this.submitMessage()
                } else {
                  window.alert(errorCount + ' of the file upload failed, please retry')
                }
              } else {
                window.alert(resp.data.message)
              }
              _this.loading = false
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.submitMessage()
        }
      }
    },
    submitMessage () {
      var _this = this
      if (_this.$refs.frmMessage.validate()) {
        _this.loading = true

        var submitData = {
          message: _this.txtMessage,
          isPrivateMessageForAdmin: _this.switchPrivateMessageForAdmin,
          isPrivateMessageForSeller: _this.switchPrivateMessageForSeller
        }

        // inject files
        if (_this.fileUploads.length > 0) {
          var fileIds = []
          for (var i in _this.fileUploads) {
            fileIds.push(_this.fileUploads[i].ticketFileId)
          }
          submitData.fileIds = fileIds
        }

        // post reply
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/reply', submitData)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              if (typeof _this.cboPendingReplyFromSellerId !== 'undefined' && _this.cboPendingReplyFromSellerId.length > 0) {
                _this.editPendingReplyStatus('seller', _this.cboPendingReplyFromSellerId)
                // editPendingReplyStatus also refresh ticket already
              } else {
                // refresh ticket
                _this.getTicket()
              }

              // reset msg form
              _this.txtMessage = ''
              _this.switchPrivateMessageForAdmin = false
              _this.switchPrivateMessageForSeller = false
              _this.cboPendingReplyFromSellerId = ''
              _this.fileUploads = []
              _this.$refs.frmMessage.reset()
            } else {
              window.alert('Unable to send message: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    showCloseTicketDialog: function () {
      this.frmCloseTicketValid = false
      this.txtCloseTicketMessage = 'We hope we have resolve your issue and we\'ll be closing this case. If you have more question please feel free to reopen this case.\r\n\r\n\r\nThank you for shopping with Martview\r\nHave a great day!'
      this.dialogCloseTicket = true
    },
    closeTicket () {
      if (this.$refs.frmCloseTicket.validate()) {
        var _this = this
        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/close', {
          message: _this.txtCloseTicketMessage
        })
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.getTicket()
              this.dialogCloseTicket = false
            } else {
              window.alert('Unable to close ticket: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
              }
              _this.loading = false
            }
          })
      }
    },
    closeTicketWithoutMsg () {
      var _this = this
      _this.loading = true
      axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + _this.ticketId + '/close', {
        message: ''
      })
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.getTicket()
            this.dialogCloseTicket = false
          } else {
            window.alert('Unable to close ticket without msg: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    }
  }
}
</script>
